import { FC } from 'react';
import cn from 'classnames';

import { DataLink } from 'components/Shared/SharedComponents';
import { capitalizeFirstLetter } from 'lib/text.service';
import { GAReplacementValue } from 'constants/enums';

import { ButtonIcon } from './Icon';
import styles from './styles.module.scss';

import { ButtonInterface } from '../config/declarations';
import { getUrl } from '../lib';

const Button: FC<ButtonInterface> = ({
  button: link,
  psychic,
  className,
  shape = 'Rectangle',
  href = '',
  onClick,
}) => {
  if (!link) {
    return null;
  }

  const { extId, psychicName } = psychic;
  const url = getUrl(
    href,
    link?.src!,
    { extid: extId.toString(), ischat: (className === 'Chat') ? '1' : undefined },
  );

  return (
    <DataLink
      link={link}
      href={url}
      className={cn(
        styles.button,
        styles[`shape${capitalizeFirstLetter(shape)}`],
        styles[`button${className}`],
      )}
      gaData={{
        [GAReplacementValue.PSYCHIC_NAME]: psychicName,
        [GAReplacementValue.EXT_ID]: extId.toString(),
      }}
      onClick={onClick}
    >
      <ButtonIcon
        isMessageButton={false}
        image={link.image}
        className={styles.buttonAsset}
      />
      <div className={styles.buttonTitle}>
        {link.title}
      </div>
    </DataLink>
  );
};

export default Button;
